import { lazy, Suspense } from "react";

const PublicFormPage = lazy(() => import("./pages/PublicFormPage").then((module) => ({ default: module.PublicFormPage })));
const Admin = lazy(() => import("./pages/Admin").then((module) => ({ default: module.Admin })));

function Loading() {
  return <div className="grid min-h-screen place-items-center bg-background"><span className="size-6 animate-spin rounded-full border-2 border-primary/20 border-t-primary" /></div>;
}

export function App() {
  const path = window.location.pathname.replace(/\/$/, "") || "/";
  if (path === "/") {
    window.location.replace("https://krnk.org/");
    return null;
  }
  if (path === "/admin" || path.startsWith("/admin/")) return <Suspense fallback={<Loading />}><Admin path={path} /></Suspense>;
  const formMatch = path.match(/^\/f\/([^/]+)$/);
  if (formMatch) return <Suspense fallback={<Loading />}><PublicFormPage slug={decodeURIComponent(formMatch[1])} /></Suspense>;
  return <div className="grid min-h-screen place-content-center gap-3 bg-background px-5 text-center"><p className="text-sm font-medium text-primary">404</p><h1 className="text-2xl font-semibold">ページが見つかりません</h1><a className="text-sm text-muted-foreground underline underline-offset-4" href="/admin">管理パネルへ戻る</a></div>;
}
